import { InferType, object, string } from 'yup'
import qs from 'qs'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  clientId: string().required(),
  groupId: string().required(),
})

export type Request = InferType<typeof Schema>

export type SuccessfulResponse = {
  data: Array<{
    configurationId: string
    startDate: string
    endDate: string
    days: Array<{ weekday: string; openTime: string; closeTime: string }>
    exceptions?: Array<{ date: string; type: string; isClosed?: boolean; openTime?: string; closeTime?: string }>
    careSite: { careSiteId: string; serviceTypes: string[] }
  }>
}

export const url = ({ clientId, groupId }: Request) =>
  `/v1/clients/${clientId}/groups/${groupId}/operating-hours-configurations?${qs.stringify({})}`
